/** دسترسی به گزارش مدیریتی: نقش admin/superadmin یا پرچم داده‌شده توسط ادمین اصلی (پس از ورود در localStorage). */
export function canAccessManagementReport(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  if (r === 'admin' || r === 'superadmin') return true;
  return localStorage.getItem('admin_management_report_access') === '1';
}

export function setManagementReportAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_management_report_access', value ? '1' : '0');
}

export function clearManagementReportAccess(): void {
  localStorage.removeItem('admin_management_report_access');
}
